<div class="page_popup_header">
  <div class="page_popup_header-left">
    <h2 class="page_popup_header-title">
      {{titre}}
    </h2>
  </div>
  <div class="page_popup_header-right">
    <ng-template [ngTemplateOutlet]="menu"></ng-template>
    <button class="button-white-icon" (click)="close()"><i class="icon icon-close"></i></button>
  </div>
</div>
